var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapcontainer",staticStyle:{"position":"relative"},attrs:{"id":"centerDiv"}},[(!_vm.isCity)?_c('mars-map',{staticStyle:{"width":"100","height":"100%"},attrs:{"url":_vm.configUrl,"options":_vm.myOptions},on:{"onload":_vm.onMapload}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }